import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const FinancialProfileFields = ({ formData, onInputChange, isSubmitting }) => (
  <div className="border-t pt-4 mt-6">
    <h3 className="text-lg font-semibold mb-2 text-gray-900">Financial Profile</h3>
    <p className="text-sm text-gray-600 mb-4">Optional - helps us prioritize applications</p>
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="annual_income">Annual Income (Optional)</Label>
        <Select value={formData.annual_income} onValueChange={(value) => onInputChange('annual_income', value)} disabled={isSubmitting}>
          <SelectTrigger><SelectValue placeholder="Select income range" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="<50K">Under $50K</SelectItem>
            <SelectItem value="50K-100K">$50K - $100K</SelectItem>
            <SelectItem value="100K-200K">$100K - $200K</SelectItem>
            <SelectItem value="200K-500K">$200K - $500K</SelectItem>
            <SelectItem value="500K-1M">$500K - $1M</SelectItem>
            <SelectItem value="1M+">Over $1M</SelectItem>
            <SelectItem value="prefer_not_say">Prefer not to say</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label htmlFor="net_worth">Net Worth (Optional)</Label>
        <Select value={formData.net_worth} onValueChange={(value) => onInputChange('net_worth', value)} disabled={isSubmitting}>
          <SelectTrigger><SelectValue placeholder="Select net worth range" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="<100K">Under $100K</SelectItem>
            <SelectItem value="100K-500K">$100K - $500K</SelectItem>
            <SelectItem value="500K-1M">$500K - $1M</SelectItem>
            <SelectItem value="1M-5M">$1M - $5M</SelectItem>
            <SelectItem value="5M-10M">$5M - $10M</SelectItem>
            <SelectItem value="10M+">Over $10M</SelectItem>
            <SelectItem value="prefer_not_say">Prefer not to say</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  </div>
);

export default FinancialProfileFields;
